import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST /system/user；password 須已為 MD5 hex。
 * @see docs/API_SYSTEM_USER.md
 */
export async function createUser(payload) {
  const { data: raw } = await request.post('/system/user', keysToSnake(payload));
  return parseVer4DetailResponse(raw);
}
